import { InferValueTypes } from "../service-types";
import * as actions from "./actions";

export enum Ace2WarrntyItemAction {
  FETCH_OPTIONS = "ACE2_FETCH_OPTIONS",
  SET_OPTIONS = "ACE2_SET_OPTIONS",
  CLEAN_UP = "ACE2_CLEAN_UP_WARRNTY_ITEM",
  ADD = "ACE2_ADD",
  UPLOAD_INVOICE = "ACE2_UPLOAD_INVOICE",
  SET_WARRNTYID_CLAIMID = "ACE2_SET_WARRNTYID_CLAIMID",
  INVOICE_UPLOAD = "ACE2_INVOICE_UPLOAD",
  SET_INVOICE_URL = "ACE2_SET_INVOICE_URL",
  SHOW_SUCCES_MODAL = "ACE2_SHOW_SUCCES_MODAL",
  HIDE_SUCCES_MODAL = "ACE2_HIDE_SUCCES_MODAL",
}

export interface Ace2WarrntyItemState {
  warrantyId: string;
  claimId: string;
  invoiceURL: string;
  options: {
    claimItemTypes: [];
    materialTypes: [];
    manufacturers: [];
    colors: [];
  };
  showSucessModal: boolean;
}

export type Ace2WarrntyItemActionTypes = ReturnType<
  InferValueTypes<typeof actions>
>;

export const Ace2WarrntyItemScope = "ace2warrntyitem";
